import OfferSimpleForm from './OfferSimpleForm'

export default OfferSimpleForm
